import Vue from 'vue'

export const BooleanField = Vue.component(
  'BooleanField',
  require('_/components/FieldTypes/BootstrapSwitch/BootstrapSwitch.vue').default
)

export const BootstrapIconPickerField = Vue.component(
  'BootstrapIconPickerField',
  require('_/components/FieldTypes/BootstrapIconPicker/BootstrapIconPicker.vue')
    .default
)

export const CalendarField = Vue.component(
  'CalendarField',
  require('_/components/FieldTypes/BootstrapDatetimepicker/BootstrapDatetimepicker.vue')
    .default
)

export const DateField = Vue.component(
  'DateField',
  require('_/components/FieldTypes/BootstrapDatetimepicker/BootstrapDatetimepicker.vue')
    .default
)

export const DateTimeField = Vue.component(
  'DateTimeField',
  require('_/components/FieldTypes/BootstrapDatetimepicker/BootstrapDatetimepicker.vue')
    .default
)

export const AssetField = Vue.component(
  'AssetField',
  require('_/components/FieldTypes/AssetsManager/AssetsManager.vue').default
)

export const AssetsField = Vue.component(
  'AssetsField',
  require('_/components/FieldTypes/AssetsManager/AssetsManager.vue').default
)

export const FileInputField = Vue.component(
  'FileInputField',
  require('_/components/FieldTypes/AssetsManager/AssetsManager.vue').default
)

export const ImageField = Vue.component(
  'ImageField',
  require('_/components/FieldTypes/FileUpload/FileUpload.vue').default
)

export const InputTextField = Vue.component(
  'InputTextField',
  require('_/components/FieldTypes/InputTag/InputTag.vue').default
)

export const IntegerField = Vue.component(
  'IntegerField',
  require('_/components/FieldTypes/InputTag/InputTag.vue').default
)

export const OneToOneField = Vue.component(
  'OneToOneField',
  require('_/components/FieldTypes/Select2/Select2.vue').default
)

export const OneToManyField = Vue.component(
  'OneToManyField',
  require('_/components/FieldTypes/Select2/Select2.vue').default
)

export const PasswordField = Vue.component(
  'PasswordField',
  require('_/components/FieldTypes/Password/Password.vue').default
)

export const PermissionsField = Vue.component(
  'PermissionsField',
  require('_/components/FieldTypes/Permissions/Permissions.vue').default
)

export const SystemDateTimeField = Vue.component(
  'SystemDateTimeField',
  require('_/components/FieldTypes/BootstrapDatetimepicker/BootstrapDatetimepicker.vue')
    .default
)

export const ManyToOneField = Vue.component(
  'ManyToOneField',
  require('_/components/FieldTypes/Select2/Select2.vue').default
)

export const RelationshipField = Vue.component(
  'RelationshipField',
  require('_/components/FieldTypes/Select2/Select2.vue').default
)

export const RichTextField = Vue.component(
  'RichTextField',
  require('_/components/FieldTypes/Redactor/Redactor.vue').default
)

export const TextareaField = Vue.component(
  'TextareaField',
  require('_/components/FieldTypes/Textarea/Textarea.vue').default
)

export const VideoField = Vue.component(
  'VideoField',
  require('_/components/FieldTypes/Video/Video.vue').default
)

export const LocationField = Vue.component(
  'LocationField',
  require('_/components/FieldTypes/Location/Location.vue').default
)

export const ColorPickerField = Vue.component(
  'ColorPickerField',
  require('_/components/FieldTypes/ColorPicker/ColorPicker.vue').default
)

export const PlainTextField = Vue.component(
  'PlainTextField',
  require('_/components/FieldTypes/Textarea/Textarea.vue').default
)

export const BigIntegerField = Vue.component(
  'BigIntegerField',
  require('_/components/FieldTypes/InputTag/InputTag.vue').default
)

export const CheckboxField = Vue.component(
  'CheckboxField',
  require('_/components/FieldTypes/Checkbox/Checkbox.vue').default
)

export const RadioField = Vue.component(
  'RadioField',
  require('_/components/FieldTypes/Radio/Radio.vue').default
)

export const ReferencesField = Vue.component(
  'ReferencesField',
  require('_/components/FieldTypes/References/References.vue').default
)

export const ModulesMultiSelectField = Vue.component(
  'ModulesMultiSelectField',
  require('_/components/FieldTypes/ModulesMultiSelect/ModulesMultiSelect.vue')
    .default
)

export const ModulesSingleSelectField = Vue.component(
  'ModulesSingleSelectField',
  require('_/components/FieldTypes/ModulesSingleSelect/ModulesSingleSelect.vue')
    .default
)

export const SectionField = Vue.component(
  'SectionField',
  require('_/components/FieldTypes/Section/Section.vue').default
)

export const IconField = Vue.component(
  'IconField',
  require('_/components/FieldTypes/Icon/Icon.vue').default
)

export const SimpleTextField = Vue.component(
  'SimpleTextField',
  require('_/components/FieldTypes/InputTag/InputTag.vue').default
)

export const Markdown = Vue.component(
  'MarkdownField',
  require('_/components/FieldTypes/Markdown/Markdown.vue').default
)
